<router-outlet></router-outlet>
<!-- Global busy UI is body #custom-loader (CommonService.showLoading); in-app .main-loading sat under mat-dialog. -->
@if (commonService.displayNotification) {
  <div class="notification-container local-notification"
    >
    <div class="notification-wrapper">
      <app-notification [message]="commonService.notificationMessage"
      (closedialog)="commonService.hideNotification()"></app-notification>
    </div>
  </div>
}